import { TranslateService } from '@ngx-translate/core';
import { markFormGroupTouched } from 'src/app/controls/components/dynamic-form/dynamic-form.component';
import { getInvalidFields } from 'src/app/functions/shared-functions';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { JobseekerRegistrationService } from './../../services/registration/jobseeker-registration.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-registration-otp',
  templateUrl: './registration-otp.component.html',
  styleUrls: ['./registration-otp.component.scss'],
  providers: [JobseekerRegistrationService]
})
export class RegistrationOtpComponent implements OnInit {
  valid_OTP = true;
  message: any;
  constructor(
    private api: JobseekerRegistrationService,
    @Inject(MAT_DIALOG_DATA) public data,
    private notification: NotificationService,
    private dialog_ref: MatDialogRef<RegistrationOtpComponent>,
    private translate: TranslateService
  ) { }
  loading: boolean = false;
  verify_btn_clicked: boolean = false;
  timer: number = 0;
  otp_resend: number = 0;
  l_attempts: number = 0;
  verification_checking = 1;
  verification_form: UntypedFormGroup = new UntypedFormGroup({
    "mobileNumber": new UntypedFormControl(null),
    "mobileIsd": new UntypedFormControl(null),
    "emailId": new UntypedFormControl(null),
    "employeeId": new UntypedFormControl(null),
    "loginId": new UntypedFormControl(null),
    "existingUser": new UntypedFormControl(null),
    "isCVMine": new UntypedFormControl(0),
    "isICR": new UntypedFormControl(0),
    "ip": new UntypedFormControl(null),
    otp: new UntypedFormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(6)])
  })
  ngOnInit(): void {
    if (this.data && this.data.value) {
      this.verification_form.patchValue(this.data.value);
    }
    if (this.data) {
      this.message = this.data.message || '';
    }

    this.timer = 30;
    let interval = setInterval(() => {
      if (this.timer > 1) {
        this.timer--;
      }
      else {
        this.timer = 0;
        clearInterval(interval)
      }
    }, 1000)
  }
  resendOTP(ev) {
    this.otp_resend++;
    this.api.sendOTP(this.verification_form.value).subscribe(res => {
      if (res && res['status']) {
        this.timer = 30;
        let interval = setInterval(() => {
          if (this.timer > 1) {
            this.timer--;
          }
          else {
            this.timer = 0;
            clearInterval(interval)
          }
        }, 1000)
        this.verification_checking = 1;
        this.message = res['message'];
        this.notification.success(res['message'], 'Close', 5000)
      }
      else {
        this.verification_checking = 0;
        this.message = res['message'];
        this.notification.error(res['message'], 'Close', 5000)
      }
    })
  }
  close() {
    this.dialog_ref.close()
  }
  verifyOTP() {
    // if (this.verification_form.value.otp === "1234") {
    //   this.verification_checking = 1;
    //   this.dialog_ref.close(this.verification_form.value);
    // }
    if (this.verification_form.valid) {
      this.api.verifyOTP(this.verification_form.value).subscribe(res => {
        if (res && res['status']) {
          this.verification_checking = 1;
          this.notification.success(res['message'], 'Close', 5000)
          this.dialog_ref.close(this.verification_form.value);
        }
        else {
          this.valid_OTP = false;
          this.notification.error(res['message'], 'Close', 5000);
          setTimeout(() => {
            this.valid_OTP = true;
          }, 5000)
        }
      })
    }
    else {
      getInvalidFields(this.verification_form, this.translate, this.notification, 'RESUME.')
      markFormGroupTouched(this.verification_form);
    }

  }
}
